import { useCallback, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { ReadManagedIdentities, ChangeIdentityAccess, CreateIdentityInvitation } from 'services/identity'
import { useHistory } from 'react-router-dom'
import { getProductAreaFromPath } from 'utils/portal'
import { exposeStrapiError } from 'utils'

export default function useManagement(areas, t, onChanged) {
  const history = useHistory()
  const invitationFormRef = useRef()
  const [invitation, setInvitation] = useState(null)
  const [area, setArea] = useState(areas[0])
  const [search, setSearch] = useState('')
  const [query, setQuery] = useState('')
  const [page, setPage] = useState(1)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [decision, setDecision] = useState(null)
  const [saving, setSaving] = useState(false)
  const request = useRef(0)
  useEffect(() => {
    const timer = setTimeout(() => { setQuery(search); setPage(1) }, 300)
    return () => clearTimeout(timer)
  }, [search])
  const load = useCallback(async () => {
    const current = ++request.current
    setLoading(true)
    const result = await ReadManagedIdentities({ area, search: query, page })
    if (current !== request.current) return
    const failed = exposeStrapiError(result) || !Array.isArray(result?.rows)
    setData(failed ? null : result)
    setError(Boolean(failed))
    setLoading(false)
  }, [area, query, page])
  useEffect(() => { load(); return () => { request.current++ } }, [load])
  const changeArea = value => { setArea(value); setPage(1); setDecision(null); setInvitation(null) }
  const reviewRequests = () => {
    const context = getProductAreaFromPath(history.location.pathname)
    history.push(context === 'lite' ? '/mvu-lite/approvals' : context === 'accelerator' ? '/mvu-accelerator/approvals' : '/approvals')
  }
  const confirm = async () => {
    if (!decision || saving) return
    const form = decision.status === 'invitation' ? invitationFormRef.current?.getForm() : null
    if (decision.status === 'invitation' && !form) return
    setSaving(true)
    const result = decision.status === 'invitation'
      ? await CreateIdentityInvitation(decision.row.id, decision.row.access.area, form.companyName)
      : await ChangeIdentityAccess(decision.row.id, decision.row.access.area, decision.status, decision.row.access.revision)
    if (!exposeStrapiError(result) && (result?.link || result?.revision > decision.row.access.revision)) {
      if (result.link) setInvitation({ ...result, email: decision.row.email })
      else toast.success(t('identity_management_saved'))
      setDecision(null)
      await load()
      if (!result.link) await onChanged?.()
    }
    setSaving(false)
  }
  return { area, search, setSearch, page, setPage, data, loading, error, load, decision, setDecision, saving, changeArea, confirm,
    invitation, invitationFormRef, reviewRequests }
}
